import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TopNotificationComponent } from "./top-notification.component";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoModule } from "@ngneat/transloco";



@NgModule({
  declarations: [
    TopNotificationComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslocoModule
  ],
  exports: [TopNotificationComponent],

})
export class TopNotificationModule { }
